export const CreditReviewDetailsTabs = {
	MerchantInformation: {
		name: "merchant-information",
		displayName: "Merchant Information",
	},
	RiskExposureCalculator: {
		name: "risk-exposure",
		displayName: "Risk Exposure Calculator",
	},
	ExecutiveSummary: {
		name: "executive-summary",
		displayName: "Executive Summary",
	},
	MerchantNotes: {
		name: "merchant-notes",
		displayName: "Merchant Notes",
	},
};
